import axios from '@/plugins/http/axios.js';
import config from "@/views/users_admin/config/users_admin_api.js";
import PathUri from '@/utils/path_uri';

const _pathUri = new PathUri(config.port, config.context);


export const service = {
    getUserAdmin: (idGroup, idEmpresa, idUsuario) => {
        return axios({
            method: 'get',
            url: `${config.baseUrl + _pathUri.generateUri() + idGroup}/user`,
            headers: {
                'idEmpresa': idEmpresa,
                'idUsuario': idUsuario
            }
        })
    },

    getUserAdminDelete: (idGroup, idEmpresa, idUsuario, userId) => {
        return axios({
            method: 'delete',
            url: `${config.baseUrl + _pathUri.generateUri() + idGroup}/user/${userId}/${idGroup}`,
            headers: {
                'idEmpresa': idEmpresa,
                'idUsuario': idUsuario
            }
        })
    },

    postUserAdminCreate: ({ idGroup, idEmpresa, idUsuario, usersAdmin }) => {
        return axios.post(
            `${config.baseUrl + _pathUri.generateUri() + idGroup}/user`,
            {
                firstName: usersAdmin.firstName,
                middleName: usersAdmin.middleName,
                lastName: usersAdmin.lastName,
                secondLastName: usersAdmin.secondLastName,
                emailAddress: usersAdmin.emailAddress,
                identificationId: usersAdmin.identificationId,
                identificationNumber: usersAdmin.identificationNumber,
                status: true,
                groupId: idGroup,
                roleId: usersAdmin.roleId,
                userDetailRequest: {
                    genderId: usersAdmin.genderId,
                    cellPhoneNumber: usersAdmin.cellPhoneNumber,
                    countryPhoneCodeId: usersAdmin.countryPhoneCodeId,
                    isFirstUserCompany: usersAdmin.isFirstUserCompany,
                    companyId: usersAdmin.isFirstUserCompany ? usersAdmin.companyId : idEmpresa,
                },
            },
            {
                headers: {
                    'Content-Type': 'application/json',
                    'idEmpresa': idEmpresa,
                    'idUsuario': idUsuario
                }
            }
        )
    },

    getUserAdminTypeRol: (idGroup, idEmpresa, idUsuario) => {

        return axios({
            method: 'get',
            url: `${config.baseUrl + _pathUri.generateUri() + idGroup}/user/roles`,
            headers: {
                'idEmpresa': idEmpresa,
                'idUsuario': idUsuario
            }
        })

    },

    getUserAdminTypDocument: (idGroup, idEmpresa, idUsuario) => {
        return axios({
            method: 'get',
            url: `${config.baseUrl + _pathUri.generateUri() + idGroup}/user/identificationTypeList`,
            headers: {
                'idEmpresa': idEmpresa,
                'idUsuario': idUsuario
            }
        })
    },

    getUserAdminId: (idGroup, idEmpresa, idUsuario, userAdmin) => { 
        return axios.get(
            `${config.baseUrl + _pathUri.generateUri() + idGroup}/user/${userAdmin}`,
            {
                headers: {
                    'idEmpresa': idEmpresa,
                    'idUsuario': idUsuario
                },

            }
        )

    },

    upDateUserAdmin: ({ idGroup, idEmpresa, idUsuario, usersAdmin }) => {
        return axios.put(
            `${config.baseUrl + _pathUri.generateUri() + idGroup}/user`,
            {
                userId: usersAdmin.userId,
                firstName: usersAdmin.firstName,
                middleName: usersAdmin.middleName,
                lastName: usersAdmin.lastName,
                secondLastName: usersAdmin.secondLastName,
                emailAddress: usersAdmin.emailAddress,
                identificationId: usersAdmin.identificationId,
                identificationNumber: usersAdmin.identificationNumber,
                status: true,
                groupId: idGroup,
                roleId: usersAdmin.roleId,
                userDetailRequest: {
                    userDetailId: usersAdmin.userDetailId,
                    genderId: usersAdmin.genderId,
                    cellPhoneNumber: usersAdmin.cellPhoneNumber,
                    countryPhoneCodeId: usersAdmin.countryPhoneCodeId,
                    isFirstUserCompany: usersAdmin.isFirstUserCompany,
                    companyId: usersAdmin.companyId
                },
            },
            {
                headers: {
                    'Content-Type': 'application/json',
                    'idEmpresa': idEmpresa,
                    'idUsuario': idUsuario
                }
            }
        )
    },


    getUserAdminCompanyId: (idGroup, idEmpresa, idUsuario, companyId) => {

        return axios.get(
            `${config.baseUrl + _pathUri.generateUri() + idGroup}/user/firstUserByCompany/${companyId}`,
            {
                headers: {
                    'idEmpresa': idEmpresa,
                    'idUsuario': idUsuario
                },

            }
        )

    },

    upDateUserAdminCompanyId: ({ idGroup, idEmpresa, idUsuario, usersAdmin }) => {
        return axios.put(
            `${config.baseUrl + _pathUri.generateUri() + idGroup}/user`,
            {
                userId: usersAdmin.userId,
                firstName: usersAdmin.firstName,
                middleName: usersAdmin.middleName,
                lastName: usersAdmin.lastName,
                secondLastName: usersAdmin.secondLastName,
                emailAddress: usersAdmin.emailAddress,
                identificationId: usersAdmin.identificationId,
                identificationNumber: usersAdmin.identificationNumber,
                status: true,
                groupId: idGroup,
                roleId: usersAdmin.roleId,
                userDetailRequest: {
                    userDetailId: usersAdmin.userDetailId,
                    genderId: usersAdmin.genderId,
                    cellPhoneNumber: usersAdmin.cellPhoneNumber,
                    countryPhoneCodeId: usersAdmin.countryPhoneCodeId,
                    isFirstUserCompany: usersAdmin.isFirstUserCompany,
                    companyId: usersAdmin.companyId
                },

            },
            {
                headers: {
                    'Content-Type': 'application/json',
                    'idEmpresa': idEmpresa,
                    'idUsuario': idUsuario
                }
            }
        )
    },

    postCargueAffiliatedUser: (idGroup, idEmpresa, idUsuario, excelFile) => {
        const formData = new FormData();
        formData.append('file', excelFile);
        return axios.post(
            `${config.baseUrl + _pathUri.generateUri() + idGroup}/test`,
            formData,
            {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'idEmpresa': idEmpresa,
                    'idUsuario': idUsuario
                }
            }
        );
    },

    getAffiliatedGender: (idGroup, idEmpresa, idUsuario) => {

        return axios({
          method: 'get',
          url: `${config.baseUrl + _pathUri.generateUri() + idGroup}/user/allgender`,
          headers: {
            'idEmpresa': idEmpresa,
            'idUsuario': idUsuario
          }
        })
    
      },

      getSearchAffiliate: (idGroup, idEmpresa, idUsuario, searchTerm) => {
        const term= searchTerm
        return axios({
            method: 'get',
            url: `${config.baseUrl + _pathUri.generateUri() + idGroup}/user/search/${term}`,
            headers: {
                'idEmpresa': idEmpresa,
                'idUsuario': idUsuario
            }
        })
    },

    getUserStatus: (idGroup, idEmpresa, idUsuario) => {
        return axios({
            method: 'get',
            url: `${config.baseUrl + _pathUri.generateUri() + idGroup}/user/allstates`,
            headers: {
                'idEmpresa': idEmpresa,
                'idUsuario': idUsuario
            }
        })

    },

    postUserStatus: ({ idGroup, idEmpresa, idUsuario, data }) => {
        return axios.post(
             `${config.baseUrl + _pathUri.generateUri() + idGroup}/user/toggleuserblock`,
             {
                stateId: data.stateId,
                observation: data.observation,
                userToBeBlocked: data.userToBeBlocked
             },
             {
                 headers: {
                     'Content-Type': 'application/json',
                     'idEmpresa': idEmpresa,
                     'idUsuario': idUsuario
                 }
             }
         )
     },
}
